import { API_ROUTES } from "../configuration/RoutesApi"
import { GetBlobRequest } from "../services/ApiClientService"

export const getImageExtensionByContentType = (contentType: string) => {
  if (contentType.includes("png")) return ".png"
  
  if (contentType.includes("webp")) return ".webp"
  
  if (contentType.includes("gif")) return ".gif"

  return ".jpg"
}

const getImageBlob = async (assetId: number, imageUrl: string): Promise<Blob> => {
  try {
    return await GetBlobRequest(API_ROUTES.IMAGE_LIBRARY.CONTENT(assetId))
  } catch {
    const response = await fetch(imageUrl.toClientRequest())

    if (!response.ok) {
      throw new Error(response.statusText)
    }

    return response.blob()
  }
}

export const getImageLibraryFile = async (assetId: number, imageUrl: string): Promise<File> => {
  const blob = await getImageBlob(assetId, imageUrl)

  const contentType = blob.type.startsWith("image/") ? blob.type : "image/jpeg"

  return new File([blob], `image-library-${assetId}${getImageExtensionByContentType(contentType)}`, {
    type: contentType,
  })
}
